<template>
  <div class="bar-chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip
} from 'chart.js';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

export default defineComponent({
  props: {
    id: {
      type: Number
    },
    title: {
      type: String
    },
    labels: {
      type: Array as () => string[],
      required: true
    },
    data: {
      type: Array as () => number[],
      required: true
    },
    chartOptions: {
      type: Object,
    }
  },

  data() {
    return {
      chart: null as Chart | null
    };
  },

  mounted() {
    this.renderChart();
  },

  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },


  watch: {
    labels: {
      deep: false,
      handler() {
        this.reRender();
      }
    },
    data: {
      deep: false,
      handler() {
        this.reRender();
      }
    },
    chartOptions: {
      deep: false,
      handler() {
        this.reRender();
      }
    }
  },

  methods: {
    renderChart() {
      const canvas = this.$refs.canvas as HTMLCanvasElement;

      const chartData = {
        labels: this.labels,
        datasets: [
          {
            label: this.title,
            data: this.data,
            borderRadius: 8,
            backgroundColor: this.chartOptions?.backgroundColor || '#0C95F2'
          }
        ]
      };

      const chartOptions = {
        ...this.chartOptions,
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;

            this.$emit("widgetAction", {
              id: this.id,
              label: this.labels[index]
            });
          }
        },
        onHover: (event, elements) => {
          const canvas = event.native?.target;
          if (!canvas) return;

          canvas.style.cursor = elements.length > 0 ? "pointer" : "default";
        }
      };

      this.chart = new Chart(canvas, {
        type: 'bar',
        data: chartData,
        options: chartOptions
      });
    },

    reRender() {
      if (this.chart) {
        this.chart.destroy();
      }
      this.renderChart();
    }
  }
});
</script>

<style scoped>
.bar-chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
